var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFile(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452-205.391h60v-203.261l83.13 83.13 42-42L480-520.087 325.435-365.522l42 42L452-408.652v203.261ZM225.087-65.869q-32.507 0-55.862-23.356-23.356-23.355-23.356-55.862v-669.826q0-32.74 23.356-56.262 23.355-23.521 55.862-23.521h362.131l227.478 227.478v522.131q0 32.507-23.521 55.862-23.522 23.356-56.262 23.356H225.087Zm320.826-563.044v-186H225.087v669.826h509.826v-483.826h-189Zm-320.826-186v186-186 669.826-669.826Z"
  })));
}
export default __webpack_public_path__ + "media/outlined/upload_file-b0df9b98.svg";
export { SvgUploadFile as ReactComponent };